import * as tslib_1 from "tslib";
import { EventEmitter } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { Location } from "@angular/common";
import { PhotosphereManager } from "../../../business/managers/photosphere.manager";
import { finalize } from "rxjs/operators";
var ArrowEditorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ArrowEditorComponent, _super);
    function ArrowEditorComponent(appComponent, router, location, alertUtils, photosphereManager) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.alertUtils = alertUtils;
        _this.photosphereManager = photosphereManager;
        _this.arrowSave = new EventEmitter();
        _this.closeSection = new EventEmitter();
        return _this;
    }
    ArrowEditorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.appComponent.startLoading();
        this.photosphereManager.getMarker(this.editedMarkerUUID)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function (marker) {
            _this.radioValue = marker.enabled ? "true" : "false";
        });
    };
    ArrowEditorComponent.prototype.onArrowSave = function () {
        if (this.radioValue === "true") {
            this.arrowSave.emit(true);
        }
        else {
            this.arrowSave.emit(false);
        }
    };
    ArrowEditorComponent.prototype.onClose = function () {
        this.closeSection.emit();
    };
    return ArrowEditorComponent;
}(BaseComponent));
export { ArrowEditorComponent };
